<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app class="ie-page">
      <v-row class="m-0 mb-1 elevation-1" style="max-height: 2.55rem">
        <v-col class="p-0">
          <v-row class="m-0" style="height: 2.55rem">
            <span class="text-h5 ie-page-title">Stammdaten-Import</span>
            <div class="t-btn-left"></div>
            <v-btn
                block
                color="primary"
                class="white--text t-btn t-btn-long"
                @click="openDialog"
            >
              <v-icon left>mdi-upload</v-icon>
              Neuen Import starten
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <div class="ie-page-body">
        <p class="text-body-2">
          Importieren Sie {{ profileNames }} aus einer Excel-Arbeitsmappe (.xlsx). Der Import prüft alle Zeilen,
          bevor etwas gespeichert wird, und legt nur an oder aktualisiert, wenn keine Zeile abgewiesen wird.
          Vorlagen und aktuelle Daten exportieren Sie über die Schaltfläche „Export“ der jeweiligen Liste.
        </p>
        <v-alert
            v-for="(warning, index) in warnings"
            :key="'warning-' + index"
            type="warning"
            dense
            text
            dismissible
            class="mb-2"
            @input="dismissWarning(index)"
        >
          {{ formatMessage(warning) }}
        </v-alert>
      </div>
    </div>
    <stammdaten-import-dialog
        v-if="dialogKey"
        :key="dialogKey"
        v-model="dialogOpen"
        :profiles="profiles"
        :api-prefix="apiPrefix"
        @imported="onImported"
    />
    <v-snackbar
        v-model="showSuccess"
        :timeout="8000"
        right
        color="success"
    >
      <b>{{ successMessage }}</b>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="showSuccess = false">
          Schließen
        </v-btn>
      </template>
    </v-snackbar>
  </v-main>
</template>

<script>
import StammdatenImportDialog from "@/views/basis_data/import_export/StammdatenImportDialog.vue";
import {formatMessage} from "@/shared/import_export_api";
import {Server_URL_ZK} from "@/shared/utils";

// the master-data profiles served by this application's backend
const PROFILES = ['KOST', 'MIGR', 'LOHN'];
const PROFILE_NAMES = 'Kostenstellen, Mitarbeitergruppen und Lohnarten';

export default {
  name: "StammdatenImportPage",
  components: {
    StammdatenImportDialog,
  },
  data() {
    return {
      profiles: PROFILES,
      profileNames: PROFILE_NAMES,
      apiPrefix: Server_URL_ZK + '/zk/basis_data/io',
      dialogKey: 0,
      dialogOpen: false,
      showSuccess: false,
      successMessage: '',
      warnings: [],
    }
  },
  mounted() {
    this.openDialog();
  },
  methods: {
    formatMessage(message) {
      return formatMessage(message);
    },
    openDialog() {
      // a new key gives every import a fresh wizard
      this.dialogKey++;
      this.dialogOpen = true;
    },
    onImported(result) {
      const counts = (result && result.counts) || {};
      const audit = (result && result.audit) || {};
      const parts = [counts.created || 0, 'angelegt,', counts.updated || 0, 'aktualisiert,', counts.unchanged || 0, 'unverändert'];
      if (counts.skipped) {
        parts.push(',', counts.skipped, 'übersprungen');
      }
      if (counts.dependents_created) {
        parts.push(',', counts.dependents_created, 'Gruppen angelegt');
      }
      this.successMessage = 'Import erfolgreich' + (audit.profile ? ' (' + audit.profile + ')' : '') + ': '
          + parts.join(' ').replace(/ ,/g, ',') + (audit.id ? ' – Protokoll-ID ' + audit.id : '');
      this.warnings = (result && result.warnings) || [];
      this.showSuccess = true;
    },
    dismissWarning(index) {
      this.warnings.splice(index, 1);
    },
  },
}
</script>

<style scoped>

.ie-page {
  flex: 1 1 auto;
  max-width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.ie-page-title {
  margin: auto 0 auto 12px;
}

.ie-page-body {
  padding: 16px 12px;
  max-width: 1100px;
}

.t-btn {
  height: 32px !important;
  width: 180px !important;
  max-width: 180px !important;
  min-width: 180px !important;
  margin: auto 12px auto 0px;
}

.t-btn-long {
  width: 240px !important;
  max-width: 240px !important;
  min-width: 240px !important;
}

.t-btn-left {
  margin: auto 12px auto auto !important;
}

</style>
